import { __ } from "@wordpress/i18n";
import {
  PanelBody,
  SelectControl,
  TextControl,
  RangeControl,
  BaseControl,
  Button,
  ButtonGroup,
  Icon,
} from "@wordpress/components";
import { alignLeft, alignCenter, alignRight } from "@wordpress/icons";

const TRIGGER_OPTIONS = [
  { label: __("Click", "brandy-blocks"), value: "click" },
  { label: __("Timer", "brandy-blocks"), value: "timer" },
  { label: __("Scroll Depth", "brandy-blocks"), value: "scroll" },
];

const ALIGN_OPTIONS = [
  { value: "left", icon: alignLeft, label: "Left" },
  { value: "center", icon: alignCenter, label: "Center" },
  { value: "right", icon: alignRight, label: "Right" },
];

export default function TriggerSettings({ attributes, setAttributes }) {
  const {
    triggerType = "click",
    buttonText = "Click Here",
    buttonAlign = "left",
    timerDelay = 3000,
    scrollDepth = 50,
  } = attributes;

  return (
    <PanelBody
      title={__("Trigger Settings", "brandy-blocks")}
      initialOpen={true}
    >
      <SelectControl
        label={__("Trigger Type", "brandy-blocks")}
        value={triggerType}
        options={TRIGGER_OPTIONS}
        onChange={(value) => setAttributes({ triggerType: value })}
      />

      {triggerType === "click" && (
        <>
          <TextControl
            label={__("Button Text", "brandy-blocks")}
            value={buttonText}
            onChange={(value) => setAttributes({ buttonText: value })}
          />
          <BaseControl label={__("Button Align", "brandy-blocks")}>
            <ButtonGroup className="brandy-align-buttons">
              {ALIGN_OPTIONS.map((option) => (
                <Button
                  key={option.value}
                  variant={buttonAlign === option.value ? "primary" : undefined}
                  onClick={() => setAttributes({ buttonAlign: option.value })}
                  className="brandy-align-button"
                >
                  <Icon icon={option.icon} />
                </Button>
              ))}
            </ButtonGroup>
          </BaseControl>
        </>
      )}

      {triggerType === "timer" && (
        <RangeControl
          label={__("Delay (ms)", "brandy-blocks")}
          value={timerDelay}
          onChange={(value) => setAttributes({ timerDelay: value })}
          min={500}
          max={30000}
          step={100}
        />
      )}

      {triggerType === "scroll" && (
        <RangeControl
          label={__("Scroll Depth (%)", "brandy-blocks")}
          value={scrollDepth}
          onChange={(value) => setAttributes({ scrollDepth: value })}
          min={5}
          max={100}
          step={5}
        />
      )}
    </PanelBody>
  );
}
